import React, { useRef, useState } from "react";
import styled from "styled-components";
import PageMargins from "~/components/styled/PageMargins";
import { Reveal } from "~/components/ui/Reveal";
import { SubMenuToggle } from "~/components/ui/SubMenuToggle";
import TextWithArrow from "~/components/ui/TextWithArrow";
import { useIsBreakpoint } from "~/hooks/useIsBreakpoint";
import { MenuItem } from "./MenuItem";
import { MenuJumpToAnchor } from "./MenuJumpToAnchor";

const Container = styled.div`
  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        padding-top:  calc(${props.theme.spacePx(
          breakpoint,
          8
        )} - calc( -1* ${props.theme.spaceFontTop(breakpoint, `h4Heading`)}));
        
        `;
    })}
`;

const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  ${(props) =>
    props.theme.apply(["base", "mobile", "tablet"], (breakpoint: string) => {
      return `
        
        margin-right: ${(
          props.theme.space(breakpoint, 7) - props.theme.space(breakpoint, 8)
        ).toFixed(2)}px;
        margin-bottom: ${props.theme.spaceFontBottom(
          breakpoint,
          breakpoint.indexOf("tablet") > -1 ? 8 : 7,
          "h4Heading"
        )};
        & > span {
          ${props.theme.textStyle(
            breakpoint.replace("Landscape", ""),
            "h4Heading"
          )};
        
            margin-right: 0;
            margin-top: ${props.theme.spaceFontBottom(
              breakpoint,
              breakpoint.indexOf("tablet") > -1 ? 8 : 7,
              "h4Heading"
            )};
            margin-right: ${props.theme.spacePx(breakpoint, 8)};
        }
      `;
    })}

  ${(props) =>
    props.theme.apply(
      ["tabletLandscape", "desktop", "screen"],
      (breakpoint: string) => {
        return `
        justify-content: flex-end;
        margin-right: 0;
        margin-left: ${(
          props.theme.space(breakpoint, 7) - props.theme.space(breakpoint, 8)
        ).toFixed(2)}px;
        margin-bottom: 0;
        margin-top: 0;
          & > span {
            ${props.theme.textStyle(breakpoint, "h4Heading")};
              margin-right: 0;
              margin-top: 0;
              margin-bottom: ${props.theme.spaceFontBottom(
                breakpoint,
                8,
                "h4Heading"
              )};
              margin-left: ${props.theme.spacePx(breakpoint, 8)};
          }
        `;
      }
    )}

  & .menu-link-active {
    color: #555;
    cursor: default;
  }
`;
const SubMenuButtonContainer = styled.div`
  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        
      `;
    })}
`;

const SubMenuFixed = styled(PageMargins)`
  position: fixed;
  top: 100px;
  width: 100%;
  left: 0px;
  z-index: 20;
  background-color: var(--ikon-bg-color, #fff);

  ${(props) =>
    props.theme.apply(["base", "mobile", "tablet"], (breakpoint: string) => {
      return `
        top: ${(
          props.theme.space(breakpoint, 5) +
          props.theme.space(breakpoint, 6) +
          1
        ).toFixed(2)}px;
        `;
    })}
`;

const BorderBottom = styled.div`
  border-bottom: 1px solid #000;
  display: flex;
  align-items: center;
  ${(props) =>
    props.theme.apply(["base", "mobile", "tablet"], (breakpoint: string) => {
      return `
        top: ${(
          props.theme.space(breakpoint, 5) +
          props.theme.space(breakpoint, 6) +
          3
        ).toFixed(2)}px;
        min-height: ${props.theme.spacePx(breakpoint, 6)};
        `;
    })}
`;

export const MenuPageSubMenu = ({ menu }: { menu: any }) => {
  const { isTabletLandscapeAndUp } = useIsBreakpoint();
  const foldMenu = !isTabletLandscapeAndUp;
  const [menuOpen, setMenuOpen] = useState(!foldMenu);

  const containerRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const nav =
    menu?.length > 0 ? (
      <Nav>
        {menu.map((page: any, index: number) => {
          return page?.anchor ? (
            <MenuJumpToAnchor
              key={`submenu-${index}`}
              title={page?.title}
              anchor={page?.anchor}
              onClick={() => setMenuOpen(false)}
            />
          ) : (
            <MenuItem key={`submenu-${index}`} item={page} onClick={() => setMenuOpen(false)}/>
          );
        })}
      </Nav>
    ) : undefined;
  return (
    <Container ref={containerRef}>
      {nav && foldMenu && (
        <SubMenuButtonContainer>
          <SubMenuToggle
            label="MENU"
            controlsId="submenu"
            isExpanded={menuOpen}
            onClick={() => {
              setMenuOpen(!menuOpen);
            }}
          />
        </SubMenuButtonContainer>
      )}
      {nav &&
        (foldMenu ? (
          <SubMenuFixed>
            <Reveal role="menu" open={menuOpen} active={foldMenu} id="submenu">
              <BorderBottom>{nav}</BorderBottom>
            </Reveal>
          </SubMenuFixed>
        ) : (
          nav
        ))}
    </Container>
  );
};
